var KEYBOARD_KEYNAMES;
(function (KEYBOARD_KEYNAMES) {
  KEYBOARD_KEYNAMES["ENTER"] = "Enter";
  KEYBOARD_KEYNAMES["SPACE"] = " ";
  KEYBOARD_KEYNAMES["TAB"] = "Tab";
  KEYBOARD_KEYNAMES["ESCAPE"] = "Escape";
  KEYBOARD_KEYNAMES["ARROW_DOWN"] = "ArrowDown";
  KEYBOARD_KEYNAMES["ARROW_LEFT"] = "ArrowLeft";
  KEYBOARD_KEYNAMES["ARROW_RIGHT"] = "ArrowRight";
  KEYBOARD_KEYNAMES["ARROW_UP"] = "ArrowUp";
  KEYBOARD_KEYNAMES["END"] = "End";
  KEYBOARD_KEYNAMES["HOME"] = "Home";
  KEYBOARD_KEYNAMES["PAGE_DOWN"] = "PageDown";
  KEYBOARD_KEYNAMES["PAGE_UP"] = "PageUp";
})(KEYBOARD_KEYNAMES || (KEYBOARD_KEYNAMES = {}));
var keys = KEYBOARD_KEYNAMES;

export { keys as k };
//# sourceMappingURL=keyboardKeynames-04a50e15-b033061a.js.map
